import { Component, Inject, AfterViewInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface DialogData {
  domain: []
}

@Component({
  selector: "access-domain-dialog",
  templateUrl: "access-domain.html",
})
export class AccessDomainDialog {
  result: any[]
  constructor(
    public dialogRef: MatDialogRef<AccessDomainDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {

    this.result = data.domain;
  }

}
